define('services/analytics/analyticsFormatter',[
    'lib/knockout',
    'lib/lodash4',
    'moment',

    'extensions/i18n/knockout.i18n' // ensure that ko.i18n is loaded.
], function (ko, _, moment) {
    'use strict';

    var EMPTY_RESULT = "-";

    var generateTimeStrFromMilliseconds = function (msTime, unit) {
        var duration = moment.duration(msTime, unit);

        var hours = Math.floor(duration.asHours());

        if (hours > 0) {
            return ko.i18n.renderString("statValue.hoursMinutesSeconds", {
                "hours":   hours,
                "minutes": (Math.floor(duration.asMinutes()) - (60 * hours)),
                "seconds": duration.seconds()
            });
        }

        return ko.i18n.renderString("statValue.minutesSeconds", {
            "minutes": Math.floor(duration.asMinutes()),
            "seconds": duration.seconds()
        });
    };

    var computeData = function (analyticsData, metricName, computationName, qualifier) {
        var data = ko.unwrap(analyticsData);
        var metricStr = ko.unwrap(metricName);

        if (!data) {
            return null;
        }
        if (qualifier) {
            return data[computationName](metricStr, qualifier);
        }
        return data[computationName](metricStr);
    };

    /**
     * Module that provides methods for formatting data in an AnalyticsData object into a
     * localized string meant for display.
     */
    var analyticsFormatter = {
        formatAverageTime: function (analyticsData, metricName, options) {
            var opts = _.assign({
                timeUnit: null // default to assume that the unit will be milliseconds
            }, options);

            var avg = computeData(analyticsData, metricName, "avg");
            if (!avg) {
                return EMPTY_RESULT;
            }

            return generateTimeStrFromMilliseconds(avg, opts.timeUnit);
        },

        formatCount: function (analyticsData, metricName) {
            var sumCount = computeData(analyticsData, metricName, "sumCount");
            if (!sumCount) {
                return EMPTY_RESULT;
            }

            return ko.i18n.format(sumCount, "n0");
        },

        /**
         * return a localized number
         * @return {[type]} [description]
         */
        formatNumberToLocalizedString: function(num) {
            if (_.isNull(num) || _.isUndefined(num)) {
                return EMPTY_RESULT;
            }

            return ko.i18n.format(num, "n0");
        },

        formatPercentage: function (num) {
            if (_.isNull(num) || _.isUndefined(num)) {
                return EMPTY_RESULT;
            }

            return ko.i18n.format(num, "p");
        },

        formatTimeFromMilliseconds: function(sum, opts) {

            return generateTimeStrFromMilliseconds(sum, opts.timeUnit);
        },

        formatSumTime: function (analyticsData, metricName, options, qualifier) {
            var opts = _.assign({
                timeUnit: null // default to assume that the unit will be milliseconds
            }, options);

            var sum = computeData(analyticsData, metricName, "sum", qualifier);
            if (!sum) {
                return EMPTY_RESULT;
            }

            return generateTimeStrFromMilliseconds(sum, opts.timeUnit);
        }
    };

    return analyticsFormatter;
}); // end define()
;
